class ProjectTemplate {
	constructor(el) {
		this.el = el;
		this.initFiltersSafetyCheck();
	}

	initFiltersSafetyCheck() {
		// Wait for DOM to be ready and patch the filters function before it's called
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => {
				this.patchFilters();
			});
		} else {
			this.patchFilters();
		}
	}

	patchFilters() {
		// Patch for Ajax Load More filters to prevent errors when filter elements don't exist
		// This needs to run before the filters script tries to access elements
		const originalFacets = window.almFiltersFacets;
		
		if (typeof originalFacets === 'function') {
			window.almFiltersFacets = function(...args) {
				try {
					// Check if filter container exists before proceeding
					const filterContainer = document.querySelector('[data-filter-id="project_filters"]');
					if (!filterContainer) {
						console.warn('Ajax Load More: Filter container not found. Filters may not be properly configured.');
						return;
					}
					return originalFacets.apply(this, args);
				} catch (error) {
					// If there's an error accessing filter elements, log it but don't break the page
					if (error && (error.message && error.message.includes('dataset') || error.message && error.message.includes('null'))) {
						console.warn('Ajax Load More filters: Filter elements not found. Filters may not be properly configured.');
						return;
					}
					// Re-throw if it's a different error
					throw error;
				}
			};
		}

		// Also ensure almComplete callback handles missing elements safely
		const originalAlmComplete = window.almComplete;
		window.almComplete = () => {
			try {
				const ajaxLoadMoreListing = document.querySelector('.alm-listing');
				if (!ajaxLoadMoreListing) {
					if (originalAlmComplete) originalAlmComplete();
					return;
				}
				
				const almFilters = ajaxLoadMoreListing.querySelector('.alm-filters');
				if (!almFilters && originalAlmComplete) {
					originalAlmComplete();
					return;
				}

				if (originalAlmComplete) originalAlmComplete();
			} catch (error) {
				console.warn('Ajax Load More: Error in almComplete callback', error);
			}
		};
	}
}

export default ProjectTemplate;

